import Toaster from "@/components/toaster";
import Protected from "@/pages/protected";
import { BloctelSuccessPage } from "@/pages/tools/bloctel/success";
import { DataService } from "@/services/data";
import { handle_error } from "@/utils/wretch";
import { Outlet, RouteObject, redirect } from "react-router-dom";

const BloctelRoute: RouteObject = {
    path: "bloctel",
    element: (
        <Protected groups={["app_tools_admin", "team_support"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { BloctelCommitPage } = await import("@/pages/tools/bloctel/commit");
                return { Component: BloctelCommitPage };
            },
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    await DataService.client.url(`/tools/bloctel/`).post(data).json();
                    return redirect(`/outils/bloctel/success`);
                } catch (e) {
                    console.error(e);
                    Toaster.error(`Une erreur est survenue`);
                    return {};
                }
            }
        },
        {
            path: "success",
            element: <BloctelSuccessPage />
        },
        {
            path: "search",
            loader: async ({ request }) => {
                const url = new URL(request.url);
                try {
                    return {
                        success: true,
                        content: await DataService.client
                            .url(`/tools/bloctel/search_mrlead/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                            .get()
                            .json()
                    };
                } catch (e) {
                    return handle_error(e);
                }
            }
        }
    ]
};
export default BloctelRoute;
